// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1___385eec15ac70a37cf8a","cls2":"BulkFollowListModal-cls2__a6af6334829e400a9c4f BulkFollowListModal-cls1___385eec15ac70a37cf8a"};